import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlotsMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_6719_10873",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 21,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .960938,
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_6719_10873)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.66895 17.2914V15.9212L4.91895 14.6712V17.2914H3.66895ZM7.00228 17.2914V12.5879L8.25228 11.3379V17.2914H7.00228ZM10.3356 17.2914V11.3379L11.5856 12.6087V17.2914H10.3356ZM13.6689 17.2914V12.6087L14.9189 11.3587V17.2914H13.6689ZM17.0023 17.2914V9.25452L18.2523 8.00452V17.2914H17.0023ZM3.66895 12.6824V10.9212L9.29395 5.29618L12.6273 8.62952L18.2523 3.00452V4.76577L12.6273 10.3908L9.29395 7.05743L3.66895 12.6824Z",
			fill: "currentColor"
		})
	})]
});
export default SvgPlotsMenu;
